import Header from "components/Header";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";

const SpeachPage = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate *************************/}
        <QuickDonate />

        {/* quick donate popup  ******************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main title  **************************/}
        <section
          className={`w-full h-[450px] lg:pt-[50px] bg-home_66 lg:bg-home_2 bg-cover  flex items-center justify-center lg:justify-start`}
        >
          <p
            className={`mainContainer w-full h-full pt-[100px] font-${
              i18n.language === "en" ? "Poppins pl-[20px]" : "Almarai pr-[20px]"
            } font-[700] text-[20px] lg:text-[32px] text-white`}
          >
            {t("The Speech of The CEO")}
          </p>
        </section>

        {/* speach section ***********************/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px] w-full px-[40px] lg:px-0 "
        >
          <div className="mainContainer flex flex-col gap-[10px]">
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "Over the long years of sincere and serious humanitarian work for this national humanitarian edifice, successive generations in the Al-Etihad Charity Foundation have been able to write a rich record of achievements that we are honored by, and we are happy to be a part of them."
              )}
            </p>

            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "Our organization has created a distinguished model in humanitarian work and has provided a unique experience in focusing on free education."
              )}
            </p>
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "The Al-Etihad Charity Foundation has built two schools for boys and girls, from which thousands of students have graduated from the flames of knowledge to create a new generation armed with knowledge, education, loyalty, and love for the Emirates, which gave them everything they need and what they wish for."
              )}
            </p>
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "In recent years, our long-established organization has completed major development and humanitarian projects in various fields, most notably drilling surface wells, building Qur’an memorization centers, providing water, and building mosques, as well as equipping a house and installing water coolers, supporting productive families, in addition to facilitating marriage."
              )}
            </p>
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "Our ancient institution has many fingerprints and shining signs in many places and regions so that we can be at the forefront of charitable institutions from the state of Zayed Al Khair, whose giving extends far and wide."
              )}
            </p>
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[400] text-[16px] lg:font-[600] lg:text-[20px] text-second_color text-center leading-10`}
            >
              {t(
                "Our organization has been and will remain, a beacon for charitable work, spreading light, knowledge, optimism, and the values of social solidarity, promoting love in society, and loyalty to our wise leadership, with your support and the presence of this distinguished elite that loves giving and works for and with it."
              )}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default SpeachPage;
